export enum StartNewApplicationEnums {
	OPENACCOUNT = 'openAccount',
	REQUESTLOAN	= 'requestLoan',
	BOTH = 'both',
}
